// suggestion_collect.bundle.js - Vue 3 入口
import { createApp, ref, reactive, onMounted, computed } from 'vue';
import SuggestionCollect from './components/SuggestionCollect.vue';
import SuggestionPortal from './components/SuggestionPortal.vue';

frappe.provide('frappe.suggestion');

frappe.suggestion = {
    _apps: {},

    init(selector = '#suggestion-app', page = 'collect') {
        if (this._apps[selector]) {
            this._apps[selector].unmount();
        }

        const component = {
            collect: SuggestionCollect,
            portal: SuggestionPortal,
        }[page] || SuggestionCollect;

        const app = createApp(component);
        this._apps[selector] = app;
        app.mount(selector);
        return app;
    },

    destroy(selector = '#suggestion-app') {
        if (this._apps[selector]) {
            this._apps[selector].unmount();
            delete this._apps[selector];
        }
    },

    reload(selector = '#suggestion-app', page = 'collect') {
        this.destroy(selector);
        return this.init(selector, page);
    }
};

export default frappe.suggestion;
